import React from "react";

// Destructive confirm for closing an N3 Trusted-Agent search request —
// Redesign 2.0 board N3-4e (close confirm), grown with the A4 running-commission
// copy (Commissioned Search, Annex A4). Close is a soft transition (no delete —
// the goldene Regel forbids destructive ops). Shared by the Section-Home list
// and the request Detail view so the two never drift. Artboard recipe: 400px
// dialog, radius 14, shadow 0 20px 50px rgba(17,24,39,0.3), padding 24, gap 12;
// footer gap 8 right-aligned, secondary "Keep it open" + danger-solid.
//
// `running` (a commission with an agent already searching) swaps the copy for
// the full A4 consequence list; without it the pending case keeps the shorter
// original wording. Containers grow downward — no fixed height (TRANSLATIONS §3).
const A4_CONSEQUENCES = [
  "The commission ends and the search stops.",
  "The commissioned request comes down from the network.",
  "Any open invitations with other agents are withdrawn.",
  "The commission chat switches to the standard 5-day timer from now — you can extend it.",
  "Your threads with players' agents are untouched.",
];

const CloseSearchRequestModal = ({ onCancel, onConfirm, busy, running = false }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-[rgba(17,24,39,0.45)] p-4">
    <div className="w-full max-w-[400px] bg-white rounded-[14px] shadow-[0_20px_50px_rgba(17,24,39,0.3)] p-6 flex flex-col gap-3">
      <span className="text-[15px] font-bold text-[#111827]">
        Close this search request?
      </span>
      {running ? (
        <ul className="flex flex-col gap-2 text-[13px] text-[#6B7280] leading-[1.55] list-none">
          {A4_CONSEQUENCES.map((line) => (
            <li key={line} className="flex gap-2">
              <span className="text-[#DC2626] flex-none mt-[1px]" aria-hidden="true">
                •
              </span>
              <span>{line}</span>
            </li>
          ))}
        </ul>
      ) : (
        <span className="text-[13px] text-[#6B7280] leading-[1.6]">
          All agents who received it will be notified the search is over. Open
          chats stay open.
        </span>
      )}
      <div className="flex justify-end gap-2 pt-1.5">
        <button
          onClick={onCancel}
          className="px-4 py-[9px] bg-white border border-[#E5E7EB] rounded-lg text-[13px] font-semibold text-[#111827] hover:bg-[#F3F4F6]"
        >
          Keep it open
        </button>
        <button
          onClick={onConfirm}
          disabled={busy}
          className="px-4 py-[9px] bg-[#DC2626] text-white rounded-lg text-[13px] font-semibold hover:bg-[#B91C1C] disabled:opacity-50"
        >
          {busy ? "Closing…" : "Close request"}
        </button>
      </div>
    </div>
  </div>
);

export default CloseSearchRequestModal;
